import { TAX_EXEMPTION_STATUS } from '@/types/plans';
import { useBillingOverviewQuery } from '@/hooks/api/queries/useBillingOverviewQuery';

export function useIsTaxExempt() {
  const { data: billingData } = useBillingOverviewQuery();

  return billingData?.customer?.tax_exempt === TAX_EXEMPTION_STATUS.Exempt;
}
